module.exports = __webpack_public_path__ + "static/media/walking.b99dc414.gif";